<mat-card>
  <h2>Neuen Zugang anlegen</h2>
  <form #registerForm id="registerForm" (ngSubmit)="onSubmit()">
    <p>
      <mat-form-field color="accent">
        <input matInput type="email" name="email" placeholder="E-Mail" [formControl]="emailFormControl" required
               email/>
        <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
          Geben Sie bitte eine gültige E-Mail-Adresse an.
        </mat-error>
        <mat-error *ngIf="emailFormControl.hasError('required')">
          Die E-Mail-Adresse ist erforderlich.
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field color="accent">
        <mat-select name="salut" placeholder="Anrede" [formControl]="salutFormControl" required>
          <mat-option value="Frau">Frau</mat-option>
          <mat-option value="Herr">Herr</mat-option>
        </mat-select>
        <mat-error *ngIf="salutFormControl.hasError('required')">
          Bitte wählen Sie ein Anrede
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field color="accent">
        <input matInput type="text" name="given_name" placeholder="Vorname" [formControl]="givenNameFormControl"
               required/>
        <mat-error *ngIf="givenNameFormControl.hasError('required')">
          Der Vorname ist erforderlich.
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field color="accent">
        <input matInput type="text" name="family_name" placeholder="Nachname"
               [formControl]="familyNameFormControl" required/>
        <mat-error *ngIf="familyNameFormControl.hasError('required')">
          Der Nachname ist erforderlich.
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <label id="industry_sector">Sie sind:</label>
      <mat-radio-group class="industry-sector"
                       required
                       aria-labelledby="industry_sector"
                       [formControl]="industrySectorFormControl">
        <mat-radio-button value="politics">Politik</mat-radio-button>
        <mat-radio-button value="business">Wirtschaft</mat-radio-button>
        <mat-radio-button value="administration">Verwaltung</mat-radio-button>
      </mat-radio-group>
      <mat-error class="industry-sector-error" *ngIf="industrySectorFormControl.hasError('required') && formSubmit">
        Die Branche ist erforderlich.
      </mat-error>
    </p>
    <p>
      <!-- <mat-form-field color="accent"> -->
      <mat-checkbox name="acceptAGB" [formControl]="checkAGBFormControl" required>Ich akzeptiere die <a
        href="https://www.staatsanzeiger.de/agb" target="_blank">Allgemeinen Geschäftsbedingungen</a>
      </mat-checkbox>
      <mat-error *ngIf="checkAGBFormControl.hasError('checked')" class="checkbox">
        Bitte bestätigen Sie unsere Allgemeinen Geschäftsbedingungen
      </mat-error>
      <!-- </mat-form-field> -->
    </p>
    <p>
      <!-- <mat-form-field color="accent"> -->
      <mat-checkbox name="acceptDSGVO" [formControl]="checkDSGVOFormControl" required>Ich
        akzeptiere die <a href="https://www.staatsanzeiger.de/datenschutz" target="_blank">Bestimmungen zum
          Datenschutz</a>
      </mat-checkbox>
      <mat-error *ngIf="checkDSGVOFormControl.hasError('checked')" class="checkbox">
        Bitte bestätigen Sie unsere Datenschutzbestimmungen
      </mat-error>
      <!-- </mat-form-field> -->
    </p>
    <p>
      <!-- <mat-form-field color="accent"> -->
      <mat-checkbox name="acceptDSGVO" [formControl]="checkNewsletterFormControl" required>
        Ich möchte den Newsletter abonnieren
      </mat-checkbox>
      <!-- </mat-form-field> -->
    </p>
    <p>
      <button mat-flat-button color="accent" type="submit">Kostenlos Registrieren</button>
    </p>
  </form>
</mat-card>

<mat-card>
  <h3 class="center">Bereits registriert?</h3>
  <button class="center" mat-stroked-button color="accent" routerLink="/">Jetzt Anmelden</button>
</mat-card>
